import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, BookOpen } from "lucide-react";

export function LeadMagnetSection() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [instagram, setInstagram] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/lead-magnet", { email, name, instagram, origin_url: window.location.origin });
      localStorage.setItem("ww_guide_popup_seen", "1");
      setDone(true);
      toast.success("Your guide is on its way to your inbox");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <section className="px-6 md:px-12 py-16 md:py-28" style={{ background: "#141311", color: "#F8F5EF" }} data-testid="lead-magnet-section">
      <div className="max-w-[900px] mx-auto text-center">
        <p className="lp-label-sm" style={{ color: "#A89880" }}>Free guide</p>
        <h2 className="lp-h mt-6 text-4xl md:text-6xl" style={{ color: "#FFFFFF" }}>
          The Metabolism<br />
          <span className="lp-it normal-case" style={{ color: "#A89880" }}>Reset Guide.</span>
        </h2>
        <div className="lp-rule mx-auto mt-8" />
        <p className="lp-it mt-8 text-xl md:text-2xl max-w-xl mx-auto leading-relaxed" style={{ color: "#D4CFC7" }}>
          5 signs your metabolism is asking for help — and the first 3 steps to heal it.
          Free, in your inbox, in seconds.
        </p>

        {done ? (
          <div className="mt-10" data-testid="lead-magnet-success">
            <p className="lp-it text-xl" style={{ color: "#D4CFC7" }}>
              Check your inbox — and you can read it right now:
            </p>
            <button className="lp-btn lp-btn-fill mt-6" onClick={() => navigate("/guide")} data-testid="read-guide-btn">
              <BookOpen size={13} /> Read the guide now <ArrowRight size={12} />
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto" data-testid="lead-magnet-form">
            <input className="input-luxe" placeholder="First name" value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ background: "rgba(255,255,255,0.06)", borderColor: "rgba(168,152,128,0.4)", color: "#FFFFFF" }}
              data-testid="lead-magnet-name" />
            <input className="input-luxe" required placeholder="Instagram handle (@you)" value={instagram}
              onChange={(e) => setInstagram(e.target.value)}
              style={{ background: "rgba(255,255,255,0.06)", borderColor: "rgba(168,152,128,0.4)", color: "#FFFFFF" }}
              data-testid="lead-magnet-instagram" />
            <input className="input-luxe" type="email" required placeholder="Your email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ background: "rgba(255,255,255,0.06)", borderColor: "rgba(168,152,128,0.4)", color: "#FFFFFF" }}
              data-testid="lead-magnet-email" />
            <button className="lp-btn lp-btn-fill whitespace-nowrap" disabled={busy} data-testid="lead-magnet-submit">
              {busy ? "Sending…" : "Send my guide"} <ArrowRight size={12} />
            </button>
          </form>
        )}
        <p className="lp-label-sm mt-10" style={{ color: "#8F8578" }}>
          Also free: <Link to="/plate" className="hover:underline" style={{ color: "#A89880" }} data-testid="plate-cross-link">How to Build Your Plate — the PHFF fridge guide →</Link>
        </p>
      </div>
    </section>
  );
}
